import React from "react";
import { Locale } from "date-fns";
import { StatementGroup } from "../types";
import StatementGroupTable from "./StatementGroupTable";

interface StatementTableListProps {
  groupedInvoices: StatementGroup[];
  onlyOutstanding: boolean;
  dateLocale?: Locale;
  cvd_type?: string;
  tr: (key: string) => string;
}

export default function StatementTableList({
  groupedInvoices,
  onlyOutstanding,
  dateLocale,
  cvd_type,
  tr,
}: StatementTableListProps) {
  if (groupedInvoices.length === 0) {
    return (
      <div className="py-12 text-center text-slate-500 border border-dashed border-slate-200 rounded-xl">
        <p className="text-sm font-medium m-0">
          {onlyOutstanding
            ? tr("No outstanding invoices found for this customer.")
            : tr("No invoices found.")}
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {groupedInvoices.map((group) => (
        <StatementGroupTable
          key={group.key}
          group={group}
          dateLocale={dateLocale}
          cvd_type={cvd_type}
          tr={tr}
        />
      ))}
    </div>
  );
}
